import React, { Component } from "react"
import './index.css';
import Button from '../../artzu-ui/src/Button'
import SelectField from '../../artzu-ui/src/SelectField'
import Option from '../../artzu-ui/src/Option'
import CheckBox from '../../artzu-ui/src/CheckBox'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';

class BookingFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { 
      parkinglotId, 
      tier, 
      shiftStart, 
      shiftEnd, 
      flexible, 
      selectParkinglot, 
      selectTier, 
      selectShiftStart,
      selectShiftEnd,
      selectFlexibility,
      formatShift,
      invalidFields,
      certification,
      bookModal,
      showPlusInfo,
      plusInfo,
      display,
      showModal,
      assignButtonAction,
      media,
      searchParams,
      accessibleVehicleClasses,
      parkinglots,
      shifts,
      resetShiftParams
    } = this.props;
    let selectedLot = parkinglots.find(({id}) => {
      return parseInt(id) == parkinglotId
    })
    return (
      <div className="book-filter">
        {bookModal()}
        {plusInfo()}
        <div className="parking-div">
          <label className="filter-label">Parking Lot</label>
          <div className="select-parking">
            {parkinglots.map((lot, index) => {
              return (
                <Button 
                  label={lot.region[0].toUpperCase() + lot.region.slice(1)} 
                  className="three-row" 
                  primary={parkinglotId === parseInt(lot.id)}
                  key={index} 
                  onClick={() => {
                    selectParkinglot(parseInt(lot.id), lot.region)
                  }}
                />
              )
            })}
            {parkinglots.length <= 1 ? <Button label={parkinglots[0].city === "toronto" ? "Mississauga" : "Pier 40"} className="three-row" disabled color="#414141"/> : null}
            {parkinglots.length <= 2 ? <Button label={parkinglots[0].city === "toronto" ? "Scarborough" : "Harlem"} className="three-row" disabled color="#414141"/> : null}
          </div>
          {selectedLot ? 
          <div>
            <p style={{ marginTop: "1em" }}>{selectedLot.address.streetAddress}<br />{selectedLot.address.city}, {selectedLot.address.province} {selectedLot.address.postalCode}</p>
            <a href={selectedLot.mapUrl} target="_blank">View Hub in Map</a>
          </div> : null}
          {invalidFields.includes("parking") ? 
          <p className="invalid-field">*select parking lot</p> : null}
        </div>
        <div className="tier-div">
          <label className="filter-label">Type of Vehicle</label>
          <div className="select-tier">
          {accessibleVehicleClasses.map((vehicleClass, index) => {
            return (
              <Button
                label={vehicleClass === "plus" ? ((certification === "plus" || certification === "plus_demo") ? 
                  vehicleClass.toUpperCase() :
                  (<span>{vehicleClass.toUpperCase()} <FontAwesomeIcon icon={faLock} /></span>)) : vehicleClass.toUpperCase()}
                className="three-row"
                onClick={vehicleClass === "plus" ? (certification === "plus" ? () => selectTier(vehicleClass) : certification === "plus_demo" ? 
                  () => {
                    resetShiftParams();
                    selectTier(vehicleClass);
                   } :
                  showPlusInfo) : () => selectTier(vehicleClass)}

                primary={tier === vehicleClass}
                color={vehicleClass === "plus" ? "#414141" : "#128DFF"}
                disabled={vehicleClass === "plus"}
                key={index}
              />
            )
          })}
            {accessibleVehicleClasses.length <= 1 ? <Button className="three-row" color="#fff" /> : null}
            {accessibleVehicleClasses.length <= 2 ? <Button className="three-row" color="#fff" /> : null}
            {/* <Button 
              label="PRO" 
              className="three-row" 
              onClick={() => selectTier("pro")} 
              primary={tier === "pro"} 
            />
            <Button 
              label={certification === "plus" || certification === "plus_demo" ? "PLUS" : (<span>PLUS <FontAwesomeIcon icon={faLock} /></span>)} 
              className="three-row" 
              onClick={certification === "plus" || certification === "plus_demo" ? 
                () => selectTier("plus") :
                showPlusInfo
              } 
              primary={tier === "plus"} 
            />
            <Button className="three-row" color="#fff" /> */}
          </div>
          {invalidFields.includes("tier") ? 
          <p className="invalid-field">*select vehicle tier</p> : null}
        </div>
        <div className="select-shift">
          <div className="select-container">
            <label className="filter-label">Start</label>
            <SelectField 
              className="two-row"
              prompt={shiftStart ? formatShift(shiftStart) : "Start"}
              width="100%"
              onChange={start => selectShiftStart(start)}
            >
              {shifts.map(shift => {
                if(certification === "plus_demo" && tier === "plus" && [3, 7, 19, 23].includes(shift)) {
                  return null;
                }
                return <Option label={formatShift(shift)} value={shift} className="shift-option" />
              })}
            </SelectField>
            <CheckBox 
              label="Flexible" 
              checkState={flexible === "start"}
              onClick={flexible === "start" ? ()=> selectFlexibility(null) : () => selectFlexibility("start")}
            />
          {invalidFields.includes("shiftStart") ? 
          <p className="invalid-field">*select a start time</p> : null}
          </div>
          <div className="select-container">
            <label className="filter-label">Finish</label>
            <SelectField 
              className="two-row"
              prompt={shiftEnd ? formatShift(shiftEnd) : "Finish"}
              width="100%"
              onChange={finish => selectShiftEnd(finish)}
            >
              {shifts.map(shift => {
                // if(certification === "plus_demo" && tier === "plus" && [3, 7, 19, 23].includes(shift)) {
                //   return null;
                // }
                return <Option label={formatShift(shift)} value={shift} className="shift-option" />
              })}
            </SelectField>
            <CheckBox 
              label="Flexible" 
              checkState={flexible === "finish"}
              onClick={flexible === "finish" ? () => selectFlexibility(null) : () => selectFlexibility("finish")}
            />
          {invalidFields.includes("shiftEnd") ? 
          <p className="invalid-field">*select an end time</p> : null}
          </div>
        </div>
        {invalidFields.length === 1 && invalidFields.includes("duration") ?
        <p className="invalid-duration">*maximum booking duration is 12 hours</p> : null}
        <p className="flex-label">*Flexible - open to other time slots</p>
        {media === "desktop" ? 
        <Button 
          className="update-filter"
          fullWidth 
          primary
          disabled={
            searchParams.parkinglotId === parkinglotId &&
            searchParams.tier === tier &&
            searchParams.shiftStart === shiftStart &&
            searchParams.shiftEnd === shiftEnd &&
            searchParams.flexible === flexible
          }
          label={display === "calendar" ? "Update" : "Search"} 
          onClick={display === "calendar" ? showModal : assignButtonAction} 
        /> : null}
      </div>
    )
  }
}

export default BookingFilter;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingFilter.js